export default __webpack_public_path__ + "assets/mexRound.4fe50ac6.svg";